import React from "react";
import normalImg from "../../assets/normal-type.gif";
import serElepeImg from "../../assets/ser-elepe-type.gif";
import CardInformation from "../Card/Information";
import Card from "../Card";

export default function PersonCard(props) {
  const person = props.person;
  return (
    <Card
      title={
        <>
          <p>tipo_: {person.type}</p>
          <b>Astro 000.079</b>
        </>
      }
      content={
        <>
          <CardInformation title="nome popular" content={person.name} />
          <CardInformation title="orbita" content="InfoJr" />
          <CardInformation
            title="objetivo da missão"
            content={person.mission}
          />
          <img
            src={person.type == "ser elepe" ? serElepeImg : normalImg}
            alt="imagem do marquitos"
          />
          <CardInformation title="bio" content={person.bio} />
        </>
      }
    />
  );
}
